export const placeData = {
	title: "Informations de contrat",
	description: "Informations générales du compte",
	loading: "Chargement...",
	accessDenied: {
		title: "Accès Refusé",
		description: "Vous n'avez pas l'autorisation d'accéder à cet écran.",
	},
	error: {
		title: "Erreur",
		description:
			"Une erreur s'est produite lors du chargement des données. Veuillez réessayer.",
	},
	sections: {
		general: {
			title: "Général",
			description: "Informations générales du compte",
		},
		fees: {
			title: "Frais",
			description:
				"Valeurs représentent les frais qui seront appliqués aux éléments ci-dessous",
		},
		balanceModel: {
			title: "Modèle de solde",
			description: "Définition du retour de solde",
		},
		grabAndGo: {
			title: "Grab and Go",
			description: "Type de livraison configuré",
		},
		eventCurrency: {
			title: "Devise de l'événement",
			description: "Devise et proportion utilisée",
		},
		smartPosSettings: {
			title: "Paramètres SmartPOS",
			description: "Données d'intégration",
		},
		communication: {
			title: "Communication",
			description: "Envoi de messages (SMS et WhatsApp)",
		},
		charges: {
			title: "Facturations",
			description: "Produits et équipements acquis",
		},
	},
	fields: {
		contractNumber: "Numéro de contrat",
		profile: "Profil",
		mainVersion: "Version principale",
		guaranteedMonthlyMinimum: "Minimum mensuel garanti",
		monthlyBillingCap: "Plafond mensuel de facturation",
		zigResponsible: "Responsable ZIG",
		placeStatus: "Statut du local",
		zigLocation: "Emplacement Zig",
		ppuAuthorizationValue: "Valeur de la préautorisation de l’application",
		rechargeNotIntegratedLimit: "Limite de recharge non intégrée",
		localResponsible: "Responsable(s) du local",
		minVersion: "Version minimale du PDV",
		placeClassification: "Classification du local",
		smsNumbers: "Numéros pour l'envoi de SMS de revenus",
		serviceFee: "Frais de service",
		deliveryFee: "Frais de livraison",
		onlineDeliveryFee: "Frais de livraison en ligne",
		advanceReservationFee: "Frais de facturation anticipée pour les réservations",
		processingFee: "Frais de traitement",
		platformFee: "Frais de plateforme",
		house: "Maison",
		status: {
			active: "Actif",
			blocked: "Bloqué",
			inactive: "Inactif",
			paused: "En pause",
		},
		profileValues: {
			barAndRestaurant: "Bar et Restaurant",
			restaurant: "Restaurant",
			concertHall: "Salle de Concerts",
			bar: "Bar",
			nightclub: 'Boîte de Nuit"',
			park: "Parc",
			sportsArena: "Arène Sportive",
			other: "Autre",
		},
		parentPlaceName: "Lieu Parent",
		nonIntegratedPaymentLimit: "Limite de paiement non intégré par appareil et événement",
		balanceReturnType: "Type de retour de solde",
		returnPeriod: "Période de retour",
		minimumBalance: "Solde minimum",
		maximumBalance: "Solde maximum",
		deliveryType: "Type de livraison",
		deliveryTime: "Temps de livraison",
		deliveryRadius: "Rayon de livraison",
		deliveryTypes: {
			counterDelivery: "Livraison au comptoir",
			tableDelivery: "Livraison à table",
		},
		deliveryPlatforms: {
			ifood: {
				brandName: "IFood",
				settlementDays: "Jours jusqu'à la liquidation d' IFood",
				fee: "Frais iFood",
				description: "Paramètres IFood",
			},
		},
		currency: "Nom",
		exchangeRate: "Proportion à la monnaie du pays",
		currencySymbol: "Symbole",
		decimalPlaces: "Places décimales",
		integrationStatus: "Statut d'intégration",
		apiVersion: "Version API",
		lastSync: "Dernière synchronisation",
		syncFrequency: "Fréquence de synchronisation",
		smsCost: "Coût de l’envoi",
		whatsappCost: "Coût de l’envoi",
		whatsappEnabled: "WhatsApp activé",
		whatsappId: "ID du service",
		pushNotifications: "Notifications push",
		placeType: "Type de Place",
		placeTypesValues: {
			default: "Par défaut",
			delivery: "Livraison",
			transfers: "Transferts",
			advance: "Avance",
			billing: "Facturation",
		},
		delveryOnlineRules: "Règles de livraison en ligne",

		zigFeeShouldBeChargedInDebit: "Facturer les frais Zig à la date de débit",
		hasCustomizedCard: "Le dépôt de garantie appartient au client",
		user: "Utilisateur",
		fiscalPrinters: "Imprimantes fiscales",
		name: "Imprimantes",
		bankAccountData: "Données de compte bancaire",
		receivingAccount: "Compte de réception",
		accountHolder: "Titulaire du compte",
		documentType: "Type de document",
		digit: "Chiffre",
		accountIdentification: "Identification du compte",
		accountIdentifier: "Identifiant du compte",
		cpfCnpj: "CPF/CNPJ",
		accountType: "Type de compte",
		accountTypes: {
			conta_corrente: "Courant",
			conta_poupanca: "Épargne",
			conta_salario: "Salaire",
		},
		registrationData: "Données à enregistrer",
		bankData: "Données bancaires",
		branch: "Agence",
		bank: "Banque",
		bankName: "Nom de la banque",
		account: "Compte",
		recharges: "Recharges",
		rechargeValidityCriteria: "Validité et critères de recharge",
		rechargesExpireIn: "Les recharges expirent dans",
		remainingRechargeActions: "Actions pour le solde de recharge",
		whatsappNumber: "Numéro",
		chargeBack: "Expirer à la fin de l'événement",
		placeOnly: "Gérées par la maison",
		normal: "Gérées par Zig",
		// Tarifs et valeurs
		rateType: "Type",
		rateTypeLabel: "Type de tarif",
		singleRate: "Tarif unique",
		segmentedFeeType: "Tarif segmenté",
		singleFeeType: "Tarif unique",
		systemFee: "Tarif du système",
		inHouseConsumption: "Consommation sur place",
		ticketOfficeRevenue: "Revenus de billetterie",
		rechargeSurplus: "Excédent de recharge",
		bonus: "Bonus",
		fixedFee: "Tarif fixe",
		appFee: "Tarif sur app",
		prechargeOnlinePaymentFee: "Tarif de pré-charge/paiement en ligne",
		fixedFeePaymentDay: "Jour de paiement du tarif fixe",
		anticipationFee: "Tarif d'anticipation",
		thirdPartyPaymentFee: "Tarif de paiement tiers",
		// Paiement avec machine ZigPay
		zigPayMachinePayment: "Paiement avec machine ZigPay",
		debit: "Débit",
		credit: "Crédit",
		creditOtherFlags: "Crédit (Autres drapeaux)",
		debitOtherFlags: "Débit (Autres drapeaux)",
		replicateRatesForAllFlags: "Répliquer les tarifs pour tous les drapeaux ?",
		pix: "Pix",
		pixKey: "Clé Pix",
		pixKeyType: "Type de Clé PIX",
		yes: "Oui",
		// Ticket restaurant
		foodVoucher: "Ticket restaurant",
		// Paiement avec machine intégrée dans l'EC du client
		integratedMachinePayment: "Paiement avec machine intégrée dans l'EC du client",
		machineCommission: "Commission des machines",
		anticipatedConsumption: "Consommation anticipée",
		anticipatedBar: "Anticipé/Bar",
		ticketOffice: "Billetterie",
		// Jours jusqu'à la collecte
		daysUntilCollection: "Jours jusqu'à la collecte",
		daysUntilCollectionDescription:
			"Nombre de jours pour exercer la collecte et les paiements dans les formats suivants",
		collectionDaysDescription:
			"Nombre de jours pour exercer la collecte et les paiements dans les formats suivants",
		// Échelonnement
		installment: "Échelonnement",
		installmentFee: "Tarif d'échelonnement",
		maxInstallments: "Nombre max. d'échéances",
		notApplicable: "Non applicable",
		// Facturations
		chargeTitle: "Titre",
		chargeCategory: "Catégorie",
		chargeRecurrence: "Récurrence",
		chargeStartDate: "Début",
		chargeEndDate: "Fin",
		chargeInstallmentValue: "Valeur de l'échéance",
		installmentRate: "Tarif d'échelonnement",
		maxInstallmentsNumber: "Nombre max. d'échéances",
		// Catégories d'ajustement
		adjustmentCategories: {
			anticipationFee: "Tarif d'Anticipation",
			balanceAdjustment: "Ajustement de Solde",
			bonifications: "Autres Bonus",
			cardActivations: "Tarif d'Activation",
			equipmentsMaintenance: "Maintenance d'Équipements",
			equipmentsPurchase: "Achat d'Équipements",
			equipmentsRental: "Location d'Équipements",
			expiredRecharges: "Recharges Expirées",
			generalZigMachineTax: "Tarifs d'Acquéreur sur Machines Intégrées",
			generalZigMachineTPV: "Facturation via acquéreur intégré ZIG",
			genericOperationsFee: "Dépenses Générales d'Exploitation",
			genericServices: "Autres Services et Facturations",
			notUsedRecharges: "Recharges Non Utilisées",
			operatorFee: "Tarif Journalier d'Opérateur",
			payments: "Paiements",
			paymentsTax: "Tarif de Paiement aux Fournisseurs",
			pos: "Facturation sur Machines Non Intégrées (POS)",
			posTax: "Tarif d'Acquéreur sur Machines Non Intégrées (POS)",
			reimbursements: "Remboursements Clients",
			systemSetup: "Configuration Système",
			totemFee: "Tarif Totem",
			wifiAssistance: "Assistance Technique Wifi",
			wifiSetup: "Configuration Wifi",
			withdraw: "Retraits",
			zigDevicePurchase: "Achat de Dispositifs de Commande",
			zigFee: "Tarif Zig",
			totenRental: "Location Totem",
			others: "Autres",
			renegotiation: "Renégociation",
			advance: "Avance",
			advanceFee: "Tarif d'Avance",
			balanceRetention: "Rétention de Solde",
			balanceTransfer: "Transfert Entre Places",
			residueRemain: "Rétention de Résidu",
			missingCards: "Cartes Manquantes",
			billingInvoice: "Facturation Note Fiscale",
			guaranteedMinimumSupplement: "Complément Minimum Garanti",
			commandFiscalPurchase: "Achat Commande Fiscale",
			accountsReceivableLegal: "CR - Juridique",
			cardDiscount: "Remise Cartes",
			discountGeneralOperatingExpenses: "Remise Dépenses Générales d'Exploitation",
			discountOperatorDailyRate: "Remise Tarif Journalier Opérateur",
			generalDiscount: "Remise Générale",
			dailyCoordinatorRate: "Tarifs Journaliers Coordinateurs",
			dailyHeadsRate: "Tarifs Journaliers Heads",
			setupDailyCoordinatorRate: "Tarifs Journaliers Setup Coordinateurs",
			setupDailyHeadsRate: "Tarifs Journaliers Setup Heads",
			setupDailySupervisorsRate: "Tarifs Journaliers Setup Superviseurs",
			setupDailyTechnicalRate: "Tarifs Journaliers Setup Technique",
			setupDailyTraineeRate: "Tarifs Journaliers Setup Stagiaire",
			dailySupervisorRate: "Tarifs Journaliers Superviseurs",
			dailyTechnicianRate: "Tarifs Journaliers Technicien",
			dailyTraineeRate: "Tarifs Journaliers Stagiaire",
			damagedEquipment: "Équipements Endommagés",
			integratedAPPBilling: "Facturation App Intégré",
			apartCreditBilling: "Facturation Crédit Séparé",
			integratedCreditBilling: "Facturation Crédit Intégré",
			apartDebitBilling: "Facturation Débit Séparé",
			integratedDebitBilling: "Facturation Débit Intégré",
			apartBillingPIX: "Facturation PIX Séparé",
			integratedPIXBilling: "Facturation PIX Intégré",
			integratedAdvancedRechargeBilling: "Facturation Recharge Anticipée Intégrée",
			interestandPenalties: "Intérêts et Pénalités",
			softwareLicense: "Licence Logiciel",
			replacedMachines: "Machines Remplacées",
			minimumGuaranteedpermachine: "Minimum Garanti par Machine",
			otherEquipment: "Autres Équipements",
			rebate: "Rabais",
			setupAdvancedRecharge: "Configuration Recharge Anticipée",
			setupRefundSite: "Configuration Site de Remboursement",
			acquirementfeeforIntegratedZIGApplication:
				"Tarif d'acquéreur sur Application ZIG Intégrée",
			acquiringfeeonapartCredit: "Tarif d'acquéreur sur Crédit Séparé",
			acquiringfeeforIntegratedCredit: "Tarif d'acquéreur sur Crédit Intégré",
			acquiringfeeforapartDebit: "Tarif d'acquéreur sur Débit Séparé",
			acquiringfeeonIntegratedDebit: "Tarif d'acquéreur sur Débit Intégré",
			acquiringfeeforapartPIX: "Tarif d'acquéreur sur PIX Séparé",
			acquiringfeeforIntegratedPIX: "Tarif d'acquéreur sur PIX Intégré",
			acquiringfeeforAdvancedRecharge: "Tarif d'acquéreur sur Recharge Anticipée",
			refundfee: "Tarif de Remboursement",
			relatedpartyretentionfee: "Tarif de Rétention de Parties Liées",
			rappiFee: "Tarif Rappi",
			SMSFee: "Tarif SMS",
			residualFee: "Tarif sur Résidu",
			cardtoCashExchange: "Échange Cartes contre Espèces",
			cardtoProductExchange: "Échange Cartes contre Produit",
			travelFood: "Alimentation Voyage",
			shipping: "Fret",
			accommodation: "Hébergement",
			transport: "Transport",
			pixRefundFee: "Tarif Remboursement PIX",
			softwareLicenseMachine: "Licence Logiciel Machine",
			softwareLicenseTotem: "Licence Logiciel Totem",
			integratedAdvanceDebitBilling: "Facturation Débit Anticipé Intégré",
			integratedAdvanceCreditBilling: "Facturation Crédit Anticipé Intégré",
			integratedAdvancePixBilling: "Facturation PIX Anticipé Intégré",
			integratedAdvanceDebitFee: "Tarif Débit Anticipé Intégré",
			integratedAdvanceCreditFee: "Tarif Crédit Anticipé Intégré",
			integratedAdvancePixFee: "Tarif PIX Anticipé Intégré",
			integratedOnlineDeliveryIncome: "Facturation Livraison En Ligne Intégrée",
			zeDeliveryDiscount: "Remise Zé Delivery",
			ticketPrinting: "Impression de Billets",
			validatorRental: "Licence Validateurs",
			zeDeliveryRetention: "Rétention Zé Delivery",
			valueAddedTax: "TVA",
			moneyTPV: "TPV Espèces",
			acquiringFeeForIntegratedInstallmentCredit:
				"Tarif d'acquéreur sur Crédit Échelonné Intégré",
			issuedCharge: "Facturation Émise",
			softwareLicenseGiftback: "Licence Logiciel Giftback",
			loanBracelet: "Prêt de Bracelet",
			lendingCards: "Prêt de Carte",
			externalResourceContribution: "Apport de Ressources Externes",
			anticipationValue: "Valeur d'Anticipation",
			anticipatedValue: "Valeur Anticipée",
			generalZigMachineCreditIn2Installments: "TPV Crédit Échelonné 2X",
			generalZigMachineCreditIn3Installments: "TPV Crédit Échelonné 3X",
			generalZigMachineCreditIn4Installments: "TPV Crédit Échelonné 4X",
			generalZigMachineCreditIn5Installments: "TPV Crédit Échelonné 5X",
			generalZigMachineCreditIn6Installments: "TPV Crédit Échelonné 6X",
			generalZigMachineCreditIn7Installments: "TPV Crédit Échelonné 7X",
			generalZigMachineCreditIn8Installments: "TPV Crédit Échelonné 8X",
			generalZigMachineCreditIn9Installments: "TPV Crédit Échelonné 9X",
			generalZigMachineCreditIn10Installments: "TPV Crédit Échelonné 10X",
			generalZigMachineCreditIn11Installments: "TPV Crédit Échelonné 11X",
			generalZigMachineCreditIn12Installments: "TPV Crédit Échelonné 12X",
			generalZigMachineCreditIn2InstallmentsFEE: "Tarif Crédit Échelonné 2X",
			generalZigMachineCreditIn3InstallmentsFEE: "Tarif Crédit Échelonné 3X",
			generalZigMachineCreditIn4InstallmentsFEE: "Tarif Crédit Échelonné 4X",
			generalZigMachineCreditIn5InstallmentsFEE: "Tarif Crédit Échelonné 5X",
			generalZigMachineCreditIn6InstallmentsFEE: "Tarif Crédit Échelonné 6X",
			generalZigMachineCreditIn7InstallmentsFEE: "Tarif Crédit Échelonné 7X",
			generalZigMachineCreditIn8InstallmentsFEE: "Tarif Crédit Échelonné 8X",
			generalZigMachineCreditIn9InstallmentsFEE: "Tarif Crédit Échelonné 9X",
			generalZigMachineCreditIn10InstallmentsFEE: "Tarif Crédit Échelonné 10X",
			generalZigMachineCreditIn11InstallmentsFEE: "Tarif Crédit Échelonné 11X",
			generalZigMachineCreditIn12InstallmentsFEE: "Tarif Crédit Échelonné 12X",
			totalTpvBarIncome: "Tarif Reçu Bar",
			totalTpvEntranceIncome: "Tarif Reçu Billetterie",
			totalTpvEntranceIncomeConsumption: "Tarif Reçu Consommation Billetterie",
			totalTpvBarMinimumConsumption: "Tarif Minimum Reçu Bar",
			totalTpvBonus: "Tarif Reçu Bonus",
			advanceRenegotiation: "Renégociation d'Avance",
			zigTicketsRetention: "Rétention Zig Tickets",
			onlineDeliveryAcquisitionFee: "Tarif d'Acquéreur sur Livraison En Ligne",
			bankRefund: "Remboursement Bancaire",
			acquirerRefund: "Remboursement Acquéreur",
			pixPreventiveBlock: "PIX - Blocage Préventif",
			pixAuthorizedUnblock: "PIX - Déblocage Autorisé",
			pixRefundByChargeback: "PIX - Remboursement par Chargeback",
			RelatedStakeholderRetentionReprocessing: "Rétention et Retraitement",
			cleaning: "Nettoyage",
			electrical: "Électrique",
			hydraulics: "Hydraulique",
			supply: "Approvisionnement",
		},
		// Récurrences
		adjustmentRecurrences: {
			daily: "Quotidienne",
			event: "Par événement",
			monthly: "Mensuelle",
			weekly: "Hebdomadaire",
		},
	},
};
